<!--  -->
<template>
  <div class="wrapper">
    <div class="literature-list">
      <div class="literature" ref="literature">
        <div class="search-box">
          <el-form :model="literatureForm" ref="dome">
            <el-form-item prop="title">
              <el-input
                v-model="literatureForm.title"
                placeholder="Title"
              ></el-input>
            </el-form-item>
            <el-form-item prop="first">
              <el-input
                v-model="literatureForm.author"
                placeholder="First author"
              ></el-input>
            </el-form-item>
            <el-form-item prop="year">
              <el-input
                v-model="literatureForm.year"
                placeholder="Year"
              ></el-input>
            </el-form-item>
            <el-form-item v-if="screenWidth > 1000">
              <el-button
                type="primary"
                icon="el-icon-search"
                class="search-btn"
                @click="searchLiterature"
              >
                Search</el-button
              >
            </el-form-item>
            <el-form-item prop="doi">
              <el-input
                v-model="literatureForm.doi"
                placeholder="Doi"
              ></el-input>
            </el-form-item>
            <el-form-item prop="tags">
              <el-input
                v-model="literatureForm.keyword"
                placeholder="Tags"
              ></el-input>
            </el-form-item>
            <el-form-item prop="publication">
              <el-input
                v-model="literatureForm.publication"
                placeholder="Publication"
              ></el-input>
            </el-form-item>
            <el-form-item v-if="screenWidth <= 1000">
              <el-button
                type="primary"
                class="search-btn"
                icon="el-icon-search"
                @click="searchLiterature"
              >
                Search</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                class="reset-btn"
                icon="el-icon-refresh-right"
                @click="reset"
                >Reset</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <v-table :tableData="tableData"></v-table>
      </div>
      <!-- <v-page :event="getResult" :showPagination="true" @getList='getList' :limit="per_page" :totalPage="totalPage" ref="page"></v-page> -->
      <el-pagination
        @current-change="handleCurrentChange"
        :total="literatureTotalCount"
        :current-page="currentPage"
        :page-size="per_page"
        layout="prev,slot,next"
      >
        <span class="rightPagination"> {{ currentPage }}/{{ totalPage }} </span>
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getliteraturelist, utlogMap } from "@/api/index";
import { functionId } from "@/utils/browser.js";
import VTable from "@/components/table/literature.vue";
import VPage from "@/components/pagenation/index";
export default {
  components: {
    VTable,
    VPage,
  },
  data() {
    return {
      totalPage: 1,
      screenWidth: 0,
      tableData: [],
      literatureTotalCount: 0,
      literatureForm: {
        title: "",
        author: "",
        year: "",
        doi: "",
        keyword: "",
        publication: "",
      },
      currentPage: 1,
      per_page: 10,
      routerName:'',
      tibetName: "TibetPlateau",
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    const that = this;
    this.routerName = this.$route.name;
    this.screenWidth = document.body.clientWidth;
    this.$nextTick(() => {
      window.onresize = () => {
        return (() => {
          window.screenWidth = document.body.clientWidth;
          that.screenWidth = window.screenWidth;
        })();
      };
    });
    this.getliteraturelist();
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getliteraturelist();
      let logMap = {
        eventType: "clk",
        url: window.location.href,
        functionId: (this.routerName == this.tibetName)?'Deepbone_tibet_literaturePageChange': 'Deepbone_explore_literaturePageChange',
      };
      utlogMap(logMap).then((res) => {
        // console.log(res);
      });
    },
    getResult(page) {
      let { title, author, year, doi, keyword, publication } =
        this.literatureForm;
      return getliteraturelist(
        this.per_page,
        page,
        title,
        author,
        year,
        doi,
        keyword,
        publication
      );
    },
    getList(tableData) {
      this.$set(this, "tableData", tableData);
    },
    getliteraturelist() {
      let { title, author, year, doi, keyword, publication } =
        this.literatureForm;
      getliteraturelist(
        this.per_page,
        this.currentPage,
        title,
        author,
        year,
        doi,
        keyword,
        publication
      ).then((res) => {
        let data = res.data?.data || [];
        let meta = res.data?.meta || {};
        let { totalCount = 0, totalPage = 0 } = meta;
        this.totalPage = totalPage;
        this.literatureTotalCount = totalCount;
        this.$set(this, "tableData", data);
      });
    },
    searchLiterature() {
      this.currentPage = 1;
      this.getliteraturelist();
      let logMap = {
        eventType: "search",
        url: window.location.href,
        functionId: (this.routerName == this.tibetName)?'Deepbone_tibet_literatureSearch' :'Deepbone_explore_literatureSearch',
        utlogMap: {
          keywords: {
            ...this.literatureForm,
          },
        },
      };
      utlogMap(logMap).then((res) => {
        // console.log(res);
      });
    },
    reset() {
      this.literatureForm.title = "";
      this.literatureForm.author = "";
      this.literatureForm.year = "";
      this.literatureForm.doi = "";
      this.literatureForm.keyword = "";
      this.literatureForm.publication = "";
      // let logMap = {
      //   eventType: "clk",
      //   url: window.location.href,
      //   functionId: functionId({
      //     pageName: "literatureIndex",
      //     module: "reset",
      //     func: "reset",
      //   })
      // };
      // utlogMap(logMap).then((res) => {
      //   console.log(res);
      // });
    },
  },
  watch: {
    screenWidth(val) {
      if (!this.timer) {
        this.screenWidth = val;
        this.timer = true;
        let that = this;
        setTimeout(function () {
          that.timer = false;
        }, 400);
      }
    },
  },
};
</script>
<style>
.literature-list {
  position: relative;
  /* max-height: 800px; */
  padding: 0 0 40px;
  width: 100%;
}
@media screen and (min-width: 1008px) {
  .el-form {
    display: flex;
    flex: 1;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
  }
  .el-form-item {
    width: 28.9%;
    margin-right: 0.9%;
  }
  .el-form-item:nth-child(4n-1) {
    margin-right: 0;
  }
  .el-form-item:nth-child(4n) {
    width: 9.9%;
    margin-right: 0;
    margin-left: 1.6%;
  }
}
@media screen and (max-width: 1008px) {
  .el-form-item:nth-child(7),
  .el-form-item:nth-child(8) {
    display: inline-block;
    width: 49%;
    margin-right: 0.9%;
  }
  .el-form-item:nth-child(8) {
    margin-right: 0;
  }
}
.el-form-item {
  margin-bottom: 12px;
}

.el-form-item__content {
  height: 40px;
}

.literature .el-input__inner {
  padding: 0 12px;
  border: 2px solid #efefef;
  border-radius: 0;
}
.literature .el-input__inner:hover,
.literature .el-input__inner:focus {
  border-color: #efefef !important;
}
.el-table th.el-table__cell > .cell {
  font-weight: 600;
}
</style>
